export const pointerIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.55811 4.45551C2.16724 3.28288 3.28284 2.16727 4.45548 2.55815L16.6012 6.60671C17.8689 7.0293 17.9929 8.77373 16.7976 9.37137L11.9958 11.7723C11.8991 11.8207 11.8206 11.8991 11.7722 11.9959L9.37134 16.7977C8.7737 17.9929 7.02927 17.869 6.60668 16.6012L2.55811 4.45551ZM4.13925 3.50683C3.74838 3.37654 3.3765 3.74841 3.5068 4.13929L7.55536 16.285C7.69622 16.7076 8.2777 16.7489 8.47691 16.3505L10.8778 11.5487C11.023 11.2584 11.2583 11.023 11.5486 10.8778L16.3504 8.47694C16.7489 8.27773 16.7075 7.69625 16.2849 7.55539L4.13925 3.50683Z"
      fill="currentColor"
    />
  </svg>
);

export const pointerIconCIM = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none" viewBox="0 0 34 34">
    <path
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeWidth="1.2"
      d="M9.7 10.2c-.3-.9.6-1.8 1.5-1.5l14.7 5c1 .3 1 1.6.2 2l-5.9 3-.5.5-3 5.9c-.4.9-1.7.8-2-.2z"
    />
  </svg>
);

export const handIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.48816 4.12195C7.29826 4.12195 7.11614 4.19738 6.98187 4.33166C6.84759 4.46594 6.77216 4.64805 6.77216 4.83795V10.9179C6.77216 11.1941 6.5483 11.4179 6.27216 11.4179C5.99601 11.4179 5.77216 11.1941 5.77216 10.9179V4.83795C5.77216 4.38284 5.95295 3.94637 6.27476 3.62455C6.59657 3.30274 7.03304 3.12195 7.48816 3.12195C7.94327 3.12195 8.37974 3.30274 8.70155 3.62455C9.02336 3.94637 9.20415 4.38284 9.20415 4.83795V10.1073C9.20415 10.3834 8.9803 10.6073 8.70415 10.6073C8.42801 10.6073 8.20415 10.3834 8.20415 10.1073V4.83795C8.20415 4.64805 8.12872 4.46594 7.99444 4.33166C7.86017 4.19738 7.67805 4.12195 7.48816 4.12195Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.92047 2.5C9.82644 2.5 9.73333 2.51852 9.64647 2.5545C9.5596 2.59048 9.48067 2.64322 9.41418 2.70971C9.34769 2.7762 9.29495 2.85513 9.25897 2.942C9.22299 3.02887 9.20447 3.12197 9.20447 3.216V4.83733C9.20447 5.11347 8.98061 5.33733 8.70447 5.33733C8.42833 5.33733 8.20447 5.11347 8.20447 4.83733V3.216C8.20447 2.99065 8.24885 2.76751 8.33509 2.55931C8.42133 2.35112 8.54773 2.16195 8.70707 2.0026C8.86642 1.84326 9.05559 1.71686 9.26378 1.63062C9.47198 1.54439 9.69512 1.5 9.92047 1.5C10.1458 1.5 10.369 1.54439 10.5772 1.63062C10.7853 1.71686 10.9745 1.84326 11.1339 2.0026C11.2932 2.16195 11.4196 2.35112 11.5058 2.55931C11.5921 2.76751 11.6365 2.99065 11.6365 3.216V10.1067C11.6365 10.3828 11.4126 10.6067 11.1365 10.6067C10.8603 10.6067 10.6365 10.3828 10.6365 10.1067V3.216C10.6365 3.12197 10.6179 3.02887 10.582 2.942C10.546 2.85513 10.4932 2.7762 10.4268 2.70971C10.3603 2.64322 10.2813 2.59048 10.1945 2.5545C10.1076 2.51852 10.0145 2.5 9.92047 2.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3524 4.12195C12.1625 4.12195 11.9804 4.19738 11.8461 4.33166C11.7118 4.46594 11.6364 4.64805 11.6364 4.83795C11.6364 5.11409 11.4126 5.33795 11.1364 5.33795C10.8603 5.33795 10.6364 5.11409 10.6364 4.83795C10.6364 4.38284 10.8172 3.94637 11.139 3.62455C11.4608 3.30274 11.8973 3.12195 12.3524 3.12195C12.8075 3.12195 13.244 3.30274 13.5658 3.62455C13.8876 3.94636 14.0684 4.38284 14.0684 4.83795V10.1073C14.0684 10.3834 13.8446 10.6073 13.5684 10.6073C13.2923 10.6073 13.0684 10.3834 13.0684 10.1073V4.83795C13.0684 4.64805 12.993 4.46594 12.8587 4.33166C12.7244 4.19738 12.5423 4.12195 12.3524 4.12195Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.784 5.74298C14.5941 5.74298 14.412 5.81842 14.2777 5.95269C14.1434 6.08697 14.068 6.26909 14.068 6.45898C14.068 6.73512 13.8441 6.95898 13.568 6.95898C13.2919 6.95898 13.068 6.73512 13.068 6.45898C13.068 6.00387 13.2488 5.5674 13.5706 5.24559C13.8924 4.92377 14.3289 4.74298 14.784 4.74298C15.2391 4.74298 15.6756 4.92377 15.9974 5.24559C16.3192 5.5674 16.5 6.00387 16.5 6.45898V13.3496C16.5 14.7723 15.9349 16.1366 14.9289 17.1426C13.923 18.1485 12.5586 18.7136 11.136 18.7136H9.68337C9.68334 18.7136 9.68339 18.7136 9.68337 18.7136H9.51466C9.48947 18.7136 9.46472 18.7118 9.44053 18.7082C8.63617 18.6719 7.84918 18.4549 7.13849 18.072C6.35642 17.6507 5.69122 17.0417 5.20264 16.2998C5.149 16.2182 5.09527 16.136 5.04205 16.054C4.7773 15.6474 3.87885 14.0801 2.36171 11.3833C2.14258 10.9938 2.08405 10.5342 2.19856 10.1022C2.31307 9.67022 2.5916 9.29995 2.9749 9.07014C3.35975 8.83927 3.8107 8.74359 4.25615 8.79829C4.70165 8.85301 5.1161 9.05501 5.43367 9.37221L6.62555 10.5641C6.82081 10.7594 6.82081 11.0759 6.62555 11.2712C6.43029 11.4665 6.11371 11.4665 5.91844 11.2712L4.72697 10.0797C4.56712 9.92005 4.3585 9.81838 4.13425 9.79084C3.91001 9.7633 3.68299 9.81148 3.48925 9.92772C3.32932 10.0236 3.21295 10.1782 3.16517 10.3584C3.11739 10.5387 3.14182 10.7305 3.23325 10.893C4.76198 13.6104 5.63878 15.138 5.88029 15.5087C5.93258 15.5892 5.9854 15.6701 6.0381 15.7503C6.4356 16.3539 6.97649 16.8489 7.61276 17.1916C8.2486 17.5342 8.9595 17.7135 9.68172 17.7136C9.68221 17.7136 9.6827 17.7136 9.6832 17.7136H11.136C12.2934 17.7136 13.4034 17.2539 14.2218 16.4355C15.0402 15.617 15.5 14.507 15.5 13.3496V6.45898C15.5 6.26909 15.4246 6.08697 15.2903 5.95269C15.156 5.81842 14.9739 5.74298 14.784 5.74298Z"
      fill="currentColor"
    />
  </svg>
);

export const templatesIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2H15C16.6569 2 18 3.34315 18 5V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V5C2 3.34315 3.34315 2 5 2ZM5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H15C16.1046 17 17 16.1046 17 15V5C17 3.89543 16.1046 3 15 3H5Z"
      fill="currentColor"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M17 7.54999H3V6.54999H17V7.54999Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 17L6.5 7.20001L7.5 7.20001L7.5 17L6.5 17Z"
      fill="currentColor"
    />
  </svg>
);

export const templatesIconCim = (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20">
    <path
      stroke="#1E1E1E"
      strokeWidth={1.2}
      d="M15.9.6a3 3 0 0 1 2.9 3v12.3a3 3 0 0 1-3 2.9H3.6a3 3 0 0 1-2.9-3V3.6a3 3 0 0 1 3-2.9H16ZM1.2 6.1h17M6 6.3v11.9"
    />
  </svg>
);

export const textIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="sidebar_Texticon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 3.5C4.22386 3.5 4 3.72386 4 4V5.59337C4 5.86951 3.77614 6.09337 3.5 6.09337C3.22386 6.09337 3 5.86951 3 5.59337V4C3 3.17157 3.67157 2.5 4.5 2.5H15.66C16.4884 2.5 17.16 3.17157 17.16 4V5.59337C17.16 5.86951 16.9361 6.09337 16.66 6.09337C16.3839 6.09337 16.16 5.86951 16.16 5.59337V4C16.16 3.72386 15.9361 3.5 15.66 3.5H4.5Z"
      fill="currentColor"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M9.60004 16.8313V3H10.6V16.8313H9.60004Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1843 17.0782C13.1843 17.3544 12.9605 17.5782 12.6843 17.5782H7.54299C7.26685 17.5782 7.04299 17.3544 7.04299 17.0782C7.04299 16.8021 7.26685 16.5782 7.54299 16.5782H12.6843C12.9605 16.5782 13.1843 16.8021 13.1843 17.0782Z"
      fill="currentColor"
    />
  </svg>
);

export const textIconCim = (
  <svg width={17} height={19} viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M.6 3.707V1.763C.6 1.121 1.12.6 1.763.6h13.44c.643 0 1.163.52 1.163 1.163v1.944"
      stroke="#1e1e1e"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
    <path stroke="#1e1e1e" strokeWidth={1.2} d="M8.506.6v16.571" />
    <path stroke="#1e1e1e" strokeWidth={1.2} strokeLinecap="round" d="M11.602 17.467H5.444" />
  </svg>
);

export const stickyNoteIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="sidebar_StickyNoteicon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 3H4C3.44771 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H11.1716C11.4368 17 11.6911 16.8946 11.8787 16.7071L16.7071 11.8787C16.8946 11.6911 17 11.4368 17 11.1716V4C17 3.44771 16.5523 3 16 3ZM4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H11.1716C11.702 18 12.2107 17.7893 12.5858 17.4142L17.4142 12.5858C17.7893 12.2107 18 11.702 18 11.1716V4C18 2.89543 17.1046 2 16 2H4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 12C10.5 11.1716 11.1716 10.5 12 10.5H17V11.5H12C11.7239 11.5 11.5 11.7239 11.5 12V18H10.5V12Z"
      fill="currentColor"
    />
  </svg>
);

export const shapeIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="sidebar_Shapeicon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.245 12.1099C9.72941 12.1099 7.69009 10.0706 7.69009 7.55494C7.69009 5.03932 9.72941 3 12.245 3C14.7607 3 16.8 5.03932 16.8 7.55494C16.8 10.0706 14.7607 12.1099 12.245 12.1099ZM6.69009 7.55494C6.69009 10.6228 9.17713 13.1099 12.245 13.1099C15.313 13.1099 17.8 10.6228 17.8 7.55494C17.8 4.48703 15.313 2 12.245 2C9.17713 2 6.69009 4.48703 6.69009 7.55494Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1035 8.89648L3 8.89648V17L11.1035 17L11.1035 8.89648ZM3 7.89648C2.44772 7.89648 2 8.3442 2 8.89648V17C2 17.5523 2.44772 18 3 18H11.1035C11.6558 18 12.1035 17.5523 12.1035 17V8.89648C12.1035 8.3442 11.6558 7.89648 11.1035 7.89648H3Z"
      fill="currentColor"
    />
  </svg>
);

export const connectorIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="sidebar_Connectoricon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1983 4.94531H11.9789V3.94531H17.1983V4.94531Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19387 6.44531C9.19387 5.0646 10.3132 3.94531 11.6939 3.94531L14.2987 3.94531L14.2987 4.94531L11.6939 4.94531C10.8654 4.94531 10.1939 5.61689 10.1939 6.44531L10.1939 15.204C10.1939 16.5847 9.07458 17.704 7.69387 17.704L2.70001 17.704C2.42387 17.704 2.20001 17.4801 2.20001 17.204C2.20001 16.9278 2.42387 16.704 2.70001 16.704L7.69387 16.704C8.5223 16.704 9.19387 16.0324 9.19387 15.204L9.19387 6.44531Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1866 2.34646C15.3819 2.1512 15.6985 2.1512 15.8937 2.34646L17.9871 4.43983L15.8937 6.53319C15.6985 6.72846 15.3819 6.72846 15.1866 6.5332C14.9913 6.33793 14.9913 6.02135 15.1866 5.82609L16.5729 4.43983L15.1866 3.05356C14.9913 2.8583 14.9913 2.54172 15.1866 2.34646Z"
      fill="currentColor"
    />
  </svg>
);

export const mindmapIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="sidebar_MindMap"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.29999 8.89856C2.29999 8.07013 2.97156 7.39856 3.79999 7.39856H6.87245C7.70088 7.39856 8.37245 8.07013 8.37245 8.89856V11.2464C8.37245 12.0748 7.70088 12.7464 6.87245 12.7464H3.79999C2.97156 12.7464 2.29999 12.0748 2.29999 11.2464V8.89856ZM3.79999 8.39856C3.52385 8.39856 3.29999 8.62242 3.29999 8.89856V11.2464C3.29999 11.5225 3.52385 11.7464 3.79999 11.7464H6.87245C7.1486 11.7464 7.37245 11.5225 7.37245 11.2464V8.89856C7.37245 8.62242 7.1486 8.39856 6.87245 8.39856H3.79999Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5535 10.1521C10.5535 9.87596 10.7774 9.6521 11.0535 9.6521L17.2999 9.6521C17.5761 9.6521 17.7999 9.87596 17.7999 10.1521C17.7999 10.4282 17.5761 10.6521 17.2999 10.6521L11.0535 10.6521C10.7774 10.6521 10.5535 10.4282 10.5535 10.1521Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5149 14.6449C15.1718 14.6449 14.8346 14.5646 14.5317 14.4118C14.2289 14.259 13.9703 14.0385 13.7766 13.7702L11.6758 10.8617C11.387 10.4617 11.0041 10.1367 10.5606 9.9128C10.1171 9.68896 9.62533 9.57247 9.12688 9.57243H7.87238C7.59623 9.57243 7.37238 9.79629 7.37238 10.0724C7.37238 10.3486 7.59623 10.5724 7.87238 10.5724L9.12681 10.5724C9.1268 10.5724 9.12682 10.5724 9.12681 10.5724C9.46981 10.5725 9.80714 10.6527 10.11 10.8055C10.4127 10.9584 10.6714 11.1789 10.8651 11.4471L12.9658 14.3557C12.9658 14.3556 12.9659 14.3557 12.9658 14.3557C13.2546 14.7556 13.6376 15.0807 14.0811 15.3045C14.5246 15.5284 15.0164 15.6449 15.5148 15.6449H17.2927C17.5688 15.6449 17.7927 15.421 17.7927 15.1449C17.7927 14.8688 17.5688 14.6449 17.2927 14.6449H15.5149C15.5149 14.6449 15.5148 14.6449 15.5149 14.6449Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5149 5.5C15.1718 5.50003 14.8346 5.58026 14.5317 5.7331C14.2289 5.88592 13.9703 6.10644 13.7766 6.37467L11.6758 9.28322C11.387 9.68317 11.0041 10.0082 10.5606 10.2321C10.1171 10.4559 9.62533 10.5724 9.12688 10.5725H7.87238C7.59623 10.5725 7.37238 10.3486 7.37238 10.0725C7.37238 9.79632 7.59623 9.57247 7.87238 9.57247L9.12681 9.57247C9.1268 9.57247 9.12682 9.57247 9.12681 9.57247C9.46981 9.57244 9.80714 9.49221 10.11 9.33936C10.4127 9.18654 10.6714 8.96603 10.8651 8.69779L12.9658 5.78924C12.9658 5.78926 12.9659 5.78923 12.9658 5.78924C13.2546 5.38932 13.6376 5.06424 14.0811 4.84037C14.5246 4.61653 15.0164 4.50004 15.5148 4.5H17.2927C17.5688 4.5 17.7927 4.72386 17.7927 5C17.7927 5.27614 17.5688 5.5 17.2927 5.5H15.5149C15.5149 5.5 15.5148 5.5 15.5149 5.5Z"
      fill="currentColor"
    />
  </svg>
);

export const taskIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4.5H4C3.44772 4.5 3 4.94772 3 5.5V14.3C3 14.8523 3.44772 15.3 4 15.3H16C16.5523 15.3 17 14.8523 17 14.3V5.5C17 4.94771 16.5523 4.5 16 4.5ZM4 3.5C2.89543 3.5 2 4.39543 2 5.5V14.3C2 15.4046 2.89543 16.3 4 16.3H16C17.1046 16.3 18 15.4046 18 14.3V5.5C18 4.39543 17.1046 3.5 16 3.5H4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00006 13.3C5.00006 13.0238 5.22392 12.8 5.50006 12.8L14.5001 12.8C14.7762 12.8 15.0001 13.0238 15.0001 13.3C15.0001 13.5761 14.7762 13.8 14.5001 13.8L5.50006 13.8C5.22392 13.8 5.00006 13.5761 5.00006 13.3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3202 6.41589C13.5323 6.59267 13.561 6.90795 13.3842 7.12009L9.66674 11.581L7.61596 9.12009C7.43918 8.90795 7.46784 8.59267 7.67998 8.41589C7.89212 8.23911 8.2074 8.26777 8.38418 8.47991L9.66674 10.019L12.616 6.47991C12.7927 6.26777 13.108 6.23911 13.3202 6.41589Z"
      fill="currentColor"
    />
  </svg>
);

export const penIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="sidebar_Penicon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3098 3.22848C12.9017 2.63421 13.705 2.29999 14.5429 2.29999C15.3809 2.29999 16.1841 2.63421 16.7761 3.22848C17.3679 3.82268 17.7 4.62818 17.7 5.46766C17.7 6.30714 17.3679 7.11264 16.7761 7.70684L7.20516 17.3158C6.92369 17.5984 6.54125 17.7572 6.1424 17.7572H3.80005C2.97162 17.7572 2.30005 17.0856 2.30005 16.2572V13.8976C2.30005 13.5008 2.45727 13.1202 2.73729 12.8391L12.3098 3.22848ZM14.5429 3.29999C13.9715 3.29999 13.423 3.52788 13.0183 3.93418L3.44579 13.5448C3.35246 13.6385 3.30005 13.7653 3.30005 13.8976V16.2572C3.30005 16.5334 3.52391 16.7572 3.80005 16.7572H6.1424C6.27535 16.7572 6.40283 16.7043 6.49665 16.6101L16.0675 7.00114C16.4723 6.59477 16.7 6.0432 16.7 5.46766C16.7 4.89212 16.4723 4.34055 16.0675 3.93418C15.6629 3.52788 15.1144 3.29999 14.5429 3.29999Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3706 4.17028C11.5662 3.97541 11.8828 3.97604 12.0777 4.17168L15.8354 7.94434C16.0303 8.13999 16.0297 8.45657 15.834 8.65145C15.6384 8.84632 15.3218 8.84569 15.1269 8.65004L11.3692 4.87739C11.1743 4.68174 11.1749 4.36516 11.3706 4.17028Z"
      fill="currentColor"
    />
  </svg>
);

export const cimPenIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="50"
    fill="none"
    viewBox="0 0 31 50"
    data-testid="sidebar_Penicon"
    style={{ transform: "translateY(10px)" }}
  >
    <defs>
      <linearGradient id="a" x1="6.1" x2="25.5" y1="31" y2="30.4" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset="1" stopColor="#E4E5EC" />
      </linearGradient>
    </defs>
    <path fill="currentColor" d="M14.6 2.7a1 1 0 0 1 1.8 0l2.4 6.8c.1.2-.1.5-.4.5h-5.8a.4.4 0 0 1-.4-.5l2.4-6.8Z" />
    <path
      fill="#000"
      fillOpacity=".2"
      d="M14.6 2.7a1 1 0 0 1 1.8 0l2.4 6.8c.1.2-.1.5-.4.5h-5.8a.4.4 0 0 1-.4-.5l2.4-6.8Z"
    />
    <path
      fill="url(#a)"
      stroke="#D4D7E4"
      d="M11.8 9.5h7.4c.2 0 .4.2.4.4l10.6 41c0 .3-.2.6-.5.6H1.3a.5.5 0 0 1-.5-.6l10.6-41c0-.2.2-.4.4-.4Z"
    />
  </svg>
);

export const commentIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4H4C3.44772 4 3 4.44772 3 5L3 16.1921L4.78999 14.6646C5.33302 14.2012 6.02348 13.9467 6.73735 13.9467H16C16.5523 13.9467 17 13.499 17 12.9467V5C17 4.44772 16.5523 4 16 4ZM4 3C2.89543 3 2 3.89543 2 5V16.1921C2 17.0454 3.00001 17.5067 3.64912 16.9528L5.43911 15.4253C5.80113 15.1164 6.26144 14.9467 6.73735 14.9467H16C17.1046 14.9467 18 14.0512 18 12.9467V5C18 3.89543 17.1046 3 16 3H4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17999 6.98608C5.17999 6.70994 5.40385 6.48608 5.67999 6.48608H14.64C14.9161 6.48608 15.14 6.70994 15.14 6.98608C15.14 7.26223 14.9161 7.48608 14.64 7.48608H5.67999C5.40385 7.48608 5.17999 7.26223 5.17999 6.98608Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17999 10.1861C5.17999 9.90995 5.40385 9.6861 5.67999 9.6861H12.08C12.3561 9.6861 12.58 9.90995 12.58 10.1861C12.58 10.4622 12.3561 10.6861 12.08 10.6861H5.67999C5.40385 10.6861 5.17999 10.4622 5.17999 10.1861Z"
      fill="currentColor"
    />
  </svg>
);

export const imageIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 3H4C3.44772 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16V4C17 3.44772 16.5523 3 16 3ZM4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2H4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.65259 9.85743L3.32308 12.6761C3.11232 12.8546 2.79682 12.8283 2.6184 12.6176C2.43997 12.4068 2.46619 12.0913 2.67694 11.9129L6.0175 9.08486C6.47566 8.71163 7.01592 8.5 7.58334 8.5C8.15077 8.5 8.69097 8.7117 9.14914 9.08493L9.15647 9.0909L13.3231 12.6184C13.5338 12.7968 13.56 13.1123 13.3816 13.3231C13.2032 13.5338 12.8877 13.56 12.6769 13.3816L8.51408 9.85742C8.21316 9.61341 7.89242 9.5 7.58334 9.5C7.27427 9.5 6.95352 9.61341 6.65259 9.85743Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8765 10.9658L11.9468 11.8612C11.7479 12.0528 11.4314 12.0468 11.2398 11.8479C11.0483 11.649 11.0542 11.3325 11.2531 11.141L12.1934 10.2354C12.6937 9.77168 13.2935 9.5 13.9333 9.5C14.5731 9.5 15.1729 9.77175 15.6732 10.2354L15.6802 10.242L17.5468 12.0399C17.7457 12.2314 17.7517 12.548 17.5601 12.7469C17.3685 12.9457 17.052 12.9517 16.8531 12.7601L14.9901 10.9658C14.6401 10.6427 14.2754 10.5 13.9333 10.5C13.5912 10.5 13.2265 10.6427 12.8765 10.9658Z"
      fill="currentColor"
    />
    <path
      d="M13.2 6.00001C13.2 6.44184 12.8418 6.80001 12.4 6.80001C11.9581 6.80001 11.6 6.44184 11.6 6.00001C11.6 5.55818 11.9581 5.20001 12.4 5.20001C12.8418 5.20001 13.2 5.55818 13.2 6.00001Z"
      fill="currentColor"
    />
  </svg>
);

export const frameIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 2C5.77614 2 6 2.22386 6 2.5L6 17.5C6 17.7761 5.77614 18 5.5 18C5.22386 18 5 17.7761 5 17.5L5 2.5C5 2.22386 5.22386 2 5.5 2Z"
      fill="#1e1e1e"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 2C14.7761 2 15 2.22386 15 2.5L15 17.5C15 17.7761 14.7761 18 14.5 18C14.2239 18 14 17.7761 14 17.5L14 2.5C14 2.22386 14.2239 2 14.5 2Z"
      fill="#1e1e1e"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 14.7C2 14.4239 2.22386 14.2 2.5 14.2L17.5 14.2C17.7761 14.2 18 14.4239 18 14.7C18 14.9762 17.7761 15.2 17.5 15.2L2.5 15.2C2.22386 15.2 2 14.9762 2 14.7Z"
      fill="#1e1e1e"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 5.5C2 5.22386 2.22386 5 2.5 5L17.5 5C17.7761 5 18 5.22386 18 5.5C18 5.77614 17.7761 6 17.5 6L2.5 6C2.22386 6 2 5.77614 2 5.5Z"
      fill="#1e1e1e"
    />
  </svg>
);

export const frameIconCim = (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20">
    <path stroke="#1e1e1e" strokeLinecap="round" strokeWidth={1.2} d="M.6 15.3H19M.6 4.3H19M15.5 19V.6M4.3 19V.6" />
  </svg>
);

export const cardStackIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.73234 2.64645C6.9276 2.84171 6.9276 3.15829 6.73234 3.35355L3.95455 6.13135L2.14645 4.32325C1.95118 4.12799 1.95118 3.81141 2.14645 3.61614C2.34171 3.42088 2.65829 3.42088 2.85355 3.61614L3.95455 4.71714L6.02524 2.64645C6.2205 2.45118 6.53708 2.45118 6.73234 2.64645Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.73234 8.46462C6.9276 8.65988 6.9276 8.97647 6.73234 9.17173L3.95455 11.9495L2.14645 10.1414C1.95118 9.94616 1.95118 9.62958 2.14645 9.43432C2.34171 9.23906 2.65829 9.23906 2.85355 9.43432L3.95455 10.5353L6.02524 8.46462C6.2205 8.26936 6.53708 8.26936 6.73234 8.46462Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.73234 14.2827C6.9276 14.478 6.9276 14.7946 6.73234 14.9898L3.95455 17.7676L2.14645 15.9595C1.95118 15.7643 1.95118 15.4477 2.14645 15.2524C2.34171 15.0572 2.65829 15.0572 2.85355 15.2524L3.95455 16.3534L6.02524 14.2827C6.2205 14.0875 6.53708 14.0875 6.73234 14.2827Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3 4.27258C10.3 3.99644 10.5238 3.77258 10.8 3.77258H17.8C18.0761 3.77258 18.3 3.99644 18.3 4.27258C18.3 4.54873 18.0761 4.77258 17.8 4.77258H10.8C10.5238 4.77258 10.3 4.54873 10.3 4.27258Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3 10.2726C10.3 9.99644 10.5238 9.77258 10.8 9.77258H17.8C18.0761 9.77258 18.3 9.99644 18.3 10.2726C18.3 10.5487 18.0761 10.7726 17.8 10.7726H10.8C10.5238 10.7726 10.3 10.5487 10.3 10.2726Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3 16.2726C10.3 15.9964 10.5238 15.7726 10.8 15.7726H17.8C18.0761 15.7726 18.3 15.9964 18.3 16.2726C18.3 16.5487 18.0761 16.7726 17.8 16.7726H10.8C10.5238 16.7726 10.3 16.5487 10.3 16.2726Z"
      fill="currentColor"
    />
  </svg>
);

export const ganttIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4022 14.3376L4.73118 14.3376C4.32736 14.3376 4 14.665 4 15.0688C4 15.4726 4.32736 15.8 4.73118 15.8L12.4022 15.8C12.8061 15.8 13.1334 15.4726 13.1334 15.0688C13.1334 14.665 12.8061 14.3376 12.4022 14.3376ZM3 15.0688C3 16.0249 3.77508 16.8 4.73118 16.8L12.4022 16.8C13.3584 16.8 14.1334 16.0249 14.1334 15.0688C14.1334 14.1127 13.3583 13.3376 12.4022 13.3376L4.73118 13.3376C3.77508 13.3376 3 14.1127 3 15.0688Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2731 9.26884L7.74565 9.26884C7.34183 9.26884 7.01447 9.5962 7.01447 10C7.01447 10.4038 7.34183 10.7312 7.74565 10.7312L16.2731 10.7312C16.6769 10.7312 17.0043 10.4038 17.0043 10C17.0043 9.5962 16.6769 9.26884 16.2731 9.26884ZM6.01447 10C6.01447 10.9561 6.78954 11.7312 7.74565 11.7312L16.2731 11.7312C17.2292 11.7312 18.0043 10.9561 18.0043 10C18.0043 9.04391 17.2292 8.26884 16.2731 8.26884L7.74565 8.26884C6.78954 8.26884 6.01447 9.04391 6.01447 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9715 3.99997L3.73118 3.99997C3.32736 3.99997 3 4.32734 3 4.73116C3 5.13498 3.32736 5.46234 3.73118 5.46234L13.9715 5.46234C14.3753 5.46234 14.7027 5.13498 14.7027 4.73116C14.7027 4.32734 14.3753 3.99997 13.9715 3.99997ZM2 4.73116C2 5.68726 2.77508 6.46234 3.73118 6.46234L13.9715 6.46234C14.9276 6.46234 15.7027 5.68726 15.7027 4.73116C15.7027 3.77505 14.9276 2.99997 13.9715 2.99997L3.73118 2.99997C2.77508 2.99997 2 3.77505 2 4.73116Z"
      fill="currentColor"
    />
  </svg>
);

export const timelineIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 17.4999C2 17.2238 2.22386 16.9999 2.5 16.9999H17.7308C18.0069 16.9999 18.2308 17.2238 18.2308 17.4999C18.2308 17.7761 18.0069 17.9999 17.7308 17.9999H2.5C2.22386 17.9999 2 17.7761 2 17.4999Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8616 17.6854L12.8616 7.02765L13.8616 7.02765L13.8616 17.6854L12.8616 17.6854Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.55774 17.6854L5.55774 7.84747L6.55774 7.84747L6.55774 17.6854L5.55774 17.6854Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.97481 6.4541C3.39201 5.86534 3.39201 4.91078 3.97481 4.32203L5.00242 3.28393C5.58522 2.69517 6.53013 2.69517 7.11293 3.28393L8.17659 4.35845C8.75939 4.9472 8.75939 5.90176 8.17659 6.49052L6.09373 8.59465L3.97481 6.4541ZM4.67832 5.03272C4.48405 5.22897 4.48405 5.54715 4.67832 5.74341L6.09373 7.17327L7.47309 5.77983C7.66735 5.58358 7.66735 5.26539 7.47309 5.06914L6.40943 3.99462C6.21516 3.79836 5.90019 3.79836 5.70592 3.99462L4.67832 5.03272Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8616 6.62964H16.4193C17.2477 6.62964 17.9193 7.30121 17.9193 8.12964V10.2288C17.9193 11.0572 17.2477 11.7288 16.4193 11.7288H12.8616V6.62964ZM13.8616 7.62964V10.7288H16.4193C16.6954 10.7288 16.9193 10.5049 16.9193 10.2288V8.12964C16.9193 7.8535 16.6954 7.62964 16.4193 7.62964H13.8616Z"
      fill="currentColor"
    />
  </svg>
);

export const tableIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="sidebar_Tableicon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5129 8.08636H2.54517V7.08636L17.5129 7.08636V8.08636Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4L4 4C3.44772 4 3 4.44772 3 5L3 15C3 15.5523 3.44772 16 4 16H16C16.5523 16 17 15.5523 17 15V5C17 4.44772 16.5523 4 16 4ZM4 3C2.89543 3 2 3.89543 2 5L2 15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3L4 3Z"
      fill="currentColor"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M17.5129 12.5H2.54517V11.5H17.5129V12.5Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.24188 16.696L7.24188 7.69598L8.24188 7.69598L8.24188 16.696L7.24188 16.696Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2419 16.696L12.2419 7.69598L13.2419 7.69598L13.2419 16.696L12.2419 16.696Z"
      fill="currentColor"
    />
  </svg>
);

export const threeDotsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="threedots"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 9.5C5 10.3284 4.32843 11 3.5 11C2.67157 11 2 10.3284 2 9.5C2 8.67157 2.67157 8 3.5 8C4.32843 8 5 8.67157 5 9.5ZM11.4 9.5C11.4 10.3284 10.7284 11 9.9 11C9.07157 11 8.4 10.3284 8.4 9.5C8.4 8.67157 9.07157 8 9.9 8C10.7284 8 11.4 8.67157 11.4 9.5ZM16.3 11C17.1284 11 17.8 10.3284 17.8 9.5C17.8 8.67157 17.1284 8 16.3 8C15.4716 8 14.8 8.67157 14.8 9.5C14.8 10.3284 15.4716 11 16.3 11Z"
      fill="currentColor"
    />
  </svg>
);

//TODO: This is not updated yet
export const chartIcon = (
  <svg width="20" height="19" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="13.8516" y="6.75" width="6.5" height="13.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="7.35156" y="0.75" width="6.5" height="19.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="0.75" y="10.1992" width="6.5" height="10.05" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const nounIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 22 23"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeMiterlimit="10"
  >
    <path d="M1.4 14.8a1 1 0 0 1 1-1h4.4a1 1 0 0 1 1 1v4.4a1 1 0 0 1-1 1H2.4a1 1 0 0 1-1-1zm12.4-13 6.4 6.4m.001-6.4-6.4 6.4M4.6 8.2a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2Zm12.313 6.15a.1.1 0 0 1 .174 0l3.29 5.7a.1.1 0 0 1-.086.15h-6.582a.1.1 0 0 1-.086-.15z" />
  </svg>
);

export const uploadFileIcon = (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.68998 14.0096C4.44612 14.0096 3.25321 13.537 2.37366 12.6957C1.49412 11.8544 1 10.7133 1 9.52353C1 8.33375 1.49412 7.1927 2.37366 6.3514C3.25321 5.5101 4.44612 5.03746 5.68998 5.03746C5.98375 3.7287 6.84316 2.57858 8.07915 1.84011C8.69114 1.47445 9.37717 1.22086 10.0981 1.09382C10.819 0.966781 11.5606 0.968775 12.2806 1.09969C13.0007 1.23061 13.685 1.48788 14.2945 1.85682C14.9041 2.22576 15.427 2.69914 15.8332 3.24994C16.2395 3.80074 16.5213 4.41816 16.6624 5.06697C16.8036 5.71577 16.8014 6.38324 16.6559 7.03127H17.6528C18.5782 7.03127 19.4657 7.39888 20.12 8.05322C20.7744 8.70757 21.142 9.59505 21.142 10.5204C21.142 11.4458 20.7744 12.3333 20.12 12.9876C19.4657 13.642 18.5782 14.0096 17.6528 14.0096H16.6559"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.68018 11.0188L10.6709 8.02808L13.6616 11.0188"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6689 8.02808V17.0002"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const nounIconCIM = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none" viewBox="0 0 34 34">
    <path
      fill="#1E1E1E"
      d="m15.9 10.7-.2 1.2H8c-1 0-1.8.8-1.8 1.8v11.6c0 1 .8 1.8 1.8 1.8h11.6c1 0 1.8-.8 1.8-1.8v-6.8l1 .1h.2v6.7a3 3 0 0 1-3 3H7.8a3 3 0 0 1-2.8-3V13.7a3 3 0 0 1 2.8-3H16Z"
    />
    <path
      stroke="#1E1E1E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="m17.6 23-4.7-4.2c-.5-.3-1-.5-1.5-.5s-1 .2-1.4.5l-4.2 3.5"
    />
    <path
      stroke="#1E1E1E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="m16 21.6 1.6-1.7a2 2 0 0 1 1.4-.7c.5 0 1 .3 1.4.7l1.6 1.7"
    />
    <g stroke="#1E1E1E" strokeMiterlimit="10" strokeWidth="1.2">
      <path d="M22.3 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" />
      <path strokeLinecap="round" d="M19.7 10.5v1.2m5.3-1.2v1.2m-5 2a2.7 2.7 0 0 0 4.6.1" />
    </g>
  </svg>
);

export const imageIconCIM = (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={18} fill="none" viewBox="0 0 22 18">
    <g stroke="#1e1e1e" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}>
      <path d="M5.4 14A5 5 0 0 1 2 12.6c-.9-.8-1.4-2-1.4-3.2S1.1 7 2 6a5 5 0 0 1 3.4-1.3A5.2 5.2 0 0 1 8 1.5a6.1 6.1 0 0 1 4.3-.8 4 4 0 0 1 2 .8c.7.4 1.3.8 1.7 1.4s.7 1.2.8 1.9c.2.7.2 1.3 0 2h1a3.6 3.6 0 1 1 0 7.2h-1" />
      <path d="m7.5 11 3-3.2 3.1 3.1m-3-3.1v9.3" />
    </g>
  </svg>
);

export const widgets_ganttChartIcon = (
  <svg width="160" height="100" viewBox="0 0 161 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1069_30)">
      <path
        d="M142.05 28.3887V77.4454C142.05 78.7812 140.967 79.8643 139.631 79.8643H33.2792V28.3887H142.05Z"
        fill="white"
        stroke="#AFB3BF"
        strokeWidth="0.574254"
      />
      <line x1="54.9389" y1="24.0462" x2="54.9389" y2="79.8602" stroke="#AFB3BF" strokeWidth="0.574254" />
      <line x1="76.9552" y1="24.0462" x2="76.9552" y2="79.8602" stroke="#AFB3BF" strokeWidth="0.574254" />
      <line x1="98.6858" y1="23.0165" x2="98.6858" y2="79.8605" stroke="#AFB3BF" strokeWidth="0.574254" />
      <path
        d="M36.4066 20.5129H139.62C140.956 20.5132 142.038 21.5962 142.038 22.9319V28.1574H33.9877V22.9319C33.9877 21.596 35.0708 20.5129 36.4066 20.5129Z"
        fill="#EEEFF4"
        stroke="#AFB3BF"
        strokeWidth="0.574254"
      />
      <mask id="path-7-inside-1_1069_30" fill="white">
        <path d="M17.8878 30.8074C17.8878 29.3131 19.0993 28.1016 20.5936 28.1016H33.714V45.9082H17.8878V30.8074Z" />
      </mask>
      <path
        d="M17.8878 30.8074C17.8878 29.3131 19.0993 28.1016 20.5936 28.1016H33.714V45.9082H17.8878V30.8074Z"
        fill="#7CE2BD"
      />
      <path
        d="M17.5712 30.8074C17.5712 29.1382 18.9244 27.785 20.5936 27.785H33.714V28.4182H20.5936C19.2741 28.4182 18.2044 29.4879 18.2044 30.8074L17.5712 30.8074ZM33.714 45.9082H17.8878H33.714ZM17.5712 45.9082V30.8074C17.5712 29.1382 18.9244 27.785 20.5936 27.785L20.5936 28.4182C19.2741 28.4182 18.2044 29.4879 18.2044 30.8074V45.9082H17.5712ZM33.714 28.1016V45.9082V28.1016Z"
        fill="#AFB3BF"
        mask="url(#path-7-inside-1_1069_30)"
      />
      <mask id="path-9-inside-2_1069_30" fill="white">
        <path d="M17.8878 63.0291H33.714V80.1508H20.5936C19.0993 80.1508 17.8878 78.9394 17.8878 77.445V63.0291Z" />
      </mask>
      <path
        d="M17.8878 63.0291H33.714V80.1508H20.5936C19.0993 80.1508 17.8878 78.9394 17.8878 77.445V63.0291Z"
        fill="#BA9AF0"
      />
      <path
        d="M17.8878 63.0291H33.714H17.8878ZM33.714 80.1508H17.8878H33.714ZM20.5936 80.1508C18.9244 80.1508 17.5712 78.7976 17.5712 77.1284V63.0291H18.2044V77.445C18.2044 78.9394 19.2741 80.1508 20.5936 80.1508H20.5936ZM33.714 63.0291V80.1508V63.0291Z"
        fill="#AFB3BF"
        mask="url(#path-9-inside-2_1069_30)"
      />
      <mask id="path-11-inside-3_1069_30" fill="white">
        <path d="M17.8878 45.9066H33.714V63.0283H17.8878V45.9066Z" />
      </mask>
      <path d="M17.8878 45.9066H33.714V63.0283H17.8878V45.9066Z" fill="#F6A09E" />
      <path
        d="M17.8878 63.0283H18.2044V45.9066H17.8878H17.5712V63.0283H17.8878Z"
        fill="#AFB3BF"
        mask="url(#path-11-inside-3_1069_30)"
      />
      <line x1="18.1498" y1="45.7255" x2="141.882" y2="45.7255" stroke="#AFB3BF" strokeWidth="0.574254" />
      <line x1="18.1498" y1="62.8473" x2="141.882" y2="62.8473" stroke="#AFB3BF" strokeWidth="0.574254" />
      <g filter="url(#filter1_d_1069_30)">
        <rect
          x="91.9894"
          y="58.235"
          width="46.7592"
          height="6.84868"
          rx="1.35291"
          transform="rotate(-180 91.9894 58.235)"
          fill="#FEC7C6"
        />
      </g>
      <path
        d="M100.619 36.3194H104.068C105.467 36.3194 106.601 37.4535 106.601 38.8524V68.7147C106.601 70.1136 107.735 71.2477 109.134 71.2477H112.849"
        stroke="#848199"
        strokeWidth="0.619015"
      />
      <path
        d="M45.2159 52.7406C45.2159 51.9934 45.8217 51.3877 46.5689 51.3877H46.6547V58.2363H46.5689C45.8217 58.2363 45.2159 57.6306 45.2159 56.8834V52.7406Z"
        fill="#F6A09E"
      />
      <path d="M119.866 28.5155L119.983 79.6434" stroke="#AFB3BF" strokeWidth="0.574254" />
      <g filter="url(#filter2_d_1069_30)">
        <rect
          x="139.48"
          y="73.9891"
          width="28.0555"
          height="6.84868"
          rx="1.35291"
          transform="rotate(-180 139.48 73.9891)"
          fill="#BA9AF0"
        />
      </g>
      <path
        d="M111.403 68.4929C111.403 67.7457 112.009 67.14 112.756 67.14H112.842V73.9887H112.756C112.009 73.9887 111.403 73.3829 111.403 72.6358V68.4929Z"
        fill="#9575C5"
      />
      <rect x="21.0266" y="35.9893" width="10.0458" height="2.04942" rx="0.67475" fill="#63B597" />
      <rect x="21.0266" y="53.0685" width="10.0458" height="2.04942" rx="0.67475" fill="#D4807E" />
      <rect x="21.0266" y="70.1462" width="10.0458" height="2.04942" rx="0.67475" fill="#9575C5" />
      <g filter="url(#filter3_d_1069_30)">
        <path
          d="M101.339 38.3936C101.339 39.1408 100.733 39.7465 99.9857 39.7465L47.2998 39.7465C46.5526 39.7465 45.9469 39.1408 45.9469 38.3936L45.9469 34.2507C45.9469 33.5035 46.5526 32.8978 47.2998 32.8978L99.9857 32.8978C100.733 32.8978 101.339 33.5035 101.339 34.2507L101.339 38.3936Z"
          fill="#A3F3D7"
        />
        <path
          d="M48.9726 36.281C48.9726 36.0978 49.1337 35.9493 49.3325 35.9493L73.8053 35.9493C74.0041 35.9493 74.1652 36.0978 74.1652 36.281C74.1652 36.4642 74.0041 36.6127 73.8053 36.6127L49.3325 36.6127C49.1337 36.6127 48.9726 36.4642 48.9726 36.281Z"
          fill="#A3F3D7"
        />
      </g>
      <path
        d="M45.9423 34.2478C45.9423 33.5006 46.548 32.8949 47.2952 32.8949H47.381V39.7436H47.2952C46.548 39.7436 45.9423 39.1379 45.9423 38.3907V34.2478Z"
        fill="#7CE2BD"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1069_30"
        x="13.8878"
        y="16.2258"
        width="132.449"
        height="67.9258"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1069_30" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1069_30" result="shape" />
      </filter>
      <filter
        id="filter1_d_1069_30"
        x="42.5243"
        y="48.6804"
        width="52.1709"
        height="12.2603"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.35291" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1069_30" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1069_30" result="shape" />
      </filter>
      <filter
        id="filter2_d_1069_30"
        x="108.719"
        y="64.4347"
        width="33.4672"
        height="12.2603"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.35291" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1069_30" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1069_30" result="shape" />
      </filter>
      <filter
        id="filter3_d_1069_30"
        x="43.241"
        y="30.192"
        width="60.8034"
        height="12.2603"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.35291" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1069_30" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1069_30" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const widgets_orgChartIcon = (
  <svg width="160" height="100" viewBox="0 0 159 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_46_51191)">
      <path
        d="M78.9453 42.2227V45.437C78.9453 47.1808 77.5293 48.5944 75.7855 48.5944C68.2153 48.5944 62.9049 48.5944 55.3346 48.5944C53.5909 48.5944 52.1748 50.008 52.1748 51.7517V53.7991"
        stroke="#7F869B"
        strokeWidth="0.803955"
      />
      <path
        d="M78.9532 42.2227V45.437C78.9532 47.1808 80.369 48.5944 82.1128 48.5944C89.9619 48.5944 95.4386 48.5944 103.288 48.5944C105.031 48.5944 106.447 50.008 106.447 51.7517V53.7991"
        stroke="#7F869B"
        strokeWidth="0.803955"
      />
      <rect x="34.6807" y="53.5703" width="35.8918" height="24.0668" rx="4.47646" fill="#DAC1FF" />
      <rect
        x="35.0826"
        y="53.9723"
        width="35.0879"
        height="23.2629"
        rx="4.07448"
        stroke="#AB87E2"
        strokeOpacity="0.9"
        strokeWidth="0.803955"
      />
      <path
        d="M39.1572 53.9727H66.0957C68.346 53.9727 70.1709 55.7966 70.1709 58.0469V69.8818H35.083V58.0469C35.083 55.7966 36.907 53.9727 39.1572 53.9727Z"
        fill="#FCFAFF"
        fillOpacity="0.9"
        stroke="#AB87E2"
        strokeWidth="0.803955"
      />
      <rect x="43.4814" y="62.9277" width="18.2845" height="1.33705" rx="0.668523" fill="#B49ED5" />
      <rect x="60.9922" y="18.375" width="35.8918" height="24.0668" rx="4.47646" fill="#D6BAFF" fillOpacity="0.9" />
      <rect
        x="61.3942"
        y="18.777"
        width="35.0879"
        height="23.2629"
        rx="4.07448"
        stroke="#AB87E2"
        strokeOpacity="0.9"
        strokeWidth="0.803955"
      />
      <path
        d="M65.4688 18.7773H92.4072C94.6575 18.7773 96.4824 20.6013 96.4824 22.8516V34.6865H61.3945V22.8516C61.3945 20.6013 63.2185 18.7773 65.4688 18.7773Z"
        fill="#FCFAFF"
        fillOpacity="0.9"
        stroke="#AB87E2"
        strokeWidth="0.803955"
      />
      <rect x="69.7949" y="27.7344" width="18.2845" height="1.33705" rx="0.668523" fill="#B49ED5" />
    </g>
    <rect x="88.3545" y="53.5703" width="35.8918" height="24.0668" rx="4.47646" fill="#D6BAFF" fillOpacity="0.9" />
    <rect
      x="88.7565"
      y="53.9723"
      width="35.0879"
      height="23.2629"
      rx="4.07448"
      stroke="#AB87E2"
      strokeOpacity="0.9"
      strokeWidth="0.803955"
    />
    <path
      d="M92.8311 53.9727H119.77C122.02 53.9727 123.845 55.7966 123.845 58.0469V69.8818H88.7568V58.0469C88.7568 55.7966 90.5808 53.9727 92.8311 53.9727Z"
      fill="#FCFAFF"
      fillOpacity="0.9"
      stroke="#AB87E2"
      strokeWidth="0.803955"
    />
    <rect x="97.1602" y="62.9277" width="18.2845" height="1.33705" rx="0.668523" fill="#B49ED5" />
    <defs>
      <filter
        id="filter0_d_46_51191"
        x="27.5969"
        y="14.8331"
        width="86.3366"
        height="73.4293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.54191" />
        <feGaussianBlur stdDeviation="3.54191" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51191" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51191" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const widgets_orgChartIconImage =
  "data:image/svg+xml,%3Csvg%20width%3D%22160%22%20height%3D%22100%22%20viewBox%3D%220%200%20160%20100%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M79.442%2042.677v3.234a3.18%203.18%200%200%201-3.18%203.177H55.683a3.18%203.18%200%200%200-3.18%203.178v2.06M79.45%2042.677v3.234a3.18%203.18%200%200%200%203.18%203.177h21.308a3.18%203.18%200%200%201%203.179%203.178v2.06%22%20stroke%3D%22%237F869B%22%20strokeWidth%3D%221.006%22%2F%3E%3Cpath%20d%3D%22M66.513%2054.096h-27.11A4.504%204.504%200%200%200%2034.9%2058.6v15.21a4.504%204.504%200%200%200%204.504%204.504h27.11a4.504%204.504%200%200%200%204.504-4.504V58.6a4.504%204.504%200%200%200-4.504-4.504%22%20fill%3D%22%23DAC1FF%22%2F%3E%3Cpath%20d%3D%22M66.513%2054.5h-27.11a4.1%204.1%200%200%200-4.1%204.1v15.21a4.1%204.1%200%200%200%204.1%204.1h27.11a4.1%204.1%200%200%200%204.1-4.1V58.6a4.1%204.1%200%200%200-4.1-4.1Z%22%20stroke%3D%22%23AB87E2%22%20strokeWidth%3D%221.006%22%2F%3E%3Cpath%20d%3D%22M39.403%2054.501h27.109a4.1%204.1%200%200%201%204.1%204.1v11.91H35.304V58.6a4.1%204.1%200%200%201%204.1-4.1Z%22%20fill%3D%22%23FCFAFF%22%20stroke%3D%22%23AB87E2%22%20strokeWidth%3D%221.006%22%2F%3E%3Cpath%20d%3D%22M61.481%2063.513H44.428a.673.673%200%201%200%200%201.345H61.48a.673.673%200%201%200%200-1.346%22%20fill%3D%22%23B49ED5%22%2F%3E%3Cpath%20d%3D%22M92.99%2018.68H65.88a4.504%204.504%200%200%200-4.504%204.503v15.21a4.504%204.504%200%200%200%204.504%204.505h27.11a4.504%204.504%200%200%200%204.503-4.505v-15.21a4.504%204.504%200%200%200-4.504-4.504%22%20fill%3D%22%23D6BAFF%22%2F%3E%3Cpath%20d%3D%22M92.99%2019.084H65.88a4.1%204.1%200%200%200-4.1%204.1v15.21a4.1%204.1%200%200%200%204.1%204.1h27.11a4.1%204.1%200%200%200%204.099-4.1v-15.21a4.1%204.1%200%200%200-4.1-4.1Z%22%20stroke%3D%22%23AB87E2%22%20strokeWidth%3D%221.006%22%2F%3E%3Cpath%20d%3D%22M65.88%2019.084h27.108a4.1%204.1%200%200%201%204.1%204.1v11.91H61.782v-11.91a4.1%204.1%200%200%201%204.1-4.1Z%22%20fill%3D%22%23FCFAFF%22%20stroke%3D%22%23AB87E2%22%20strokeWidth%3D%221.006%22%2F%3E%3Cpath%20d%3D%22M87.96%2028.097H70.908a.673.673%200%201%200%200%201.345h17.054a.673.673%200%201%200%200-1.345%22%20fill%3D%22%23B49ED5%22%2F%3E%3Cpath%20d%3D%22M120.524%2054.096h-27.11a4.504%204.504%200%200%200-4.503%204.504v15.21a4.504%204.504%200%200%200%204.504%204.504h27.109a4.504%204.504%200%200%200%204.504-4.504V58.6a4.504%204.504%200%200%200-4.504-4.504%22%20fill%3D%22%23D6BAFF%22%2F%3E%3Cpath%20d%3D%22M120.524%2054.5h-27.11a4.1%204.1%200%200%200-4.099%204.1v15.21a4.1%204.1%200%200%200%204.1%204.1h27.109a4.1%204.1%200%200%200%204.1-4.1V58.6a4.1%204.1%200%200%200-4.1-4.1Z%22%20stroke%3D%22%23AB87E2%22%20strokeWidth%3D%221.006%22%2F%3E%3Cpath%20d%3D%22M93.415%2054.501h27.108a4.1%204.1%200%200%201%204.101%204.1v11.91H89.315V58.6a4.1%204.1%200%200%201%204.1-4.1Z%22%20fill%3D%22%23FCFAFF%22%20stroke%3D%22%23AB87E2%22%20strokeWidth%3D%221.006%22%2F%3E%3Cpath%20d%3D%22M115.498%2063.513H98.444a.673.673%200%201%200%200%201.345h17.054a.673.673%200%201%200%200-1.346%22%20fill%3D%22%23B49ED5%22%2F%3E%3C%2Fsvg%3E";

export const widgets_cardStackIcon = (
  <svg width="160" height="100" viewBox="0 0 159 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_46_51003)">
      <path
        d="M117.377 27.9785L25.6769 27.9785L25.6769 25.5654C25.6769 21.5671 28.9181 18.3259 32.9164 18.3259L110.137 18.3259C114.136 18.3259 117.377 21.5671 117.377 25.5654L117.377 27.9785Z"
        fill="#FFB4C9"
      />
      <g filter="url(#filter1_d_46_51003)">
        <path
          d="M25.6836 27.9778C25.6836 23.9795 28.9248 20.7383 32.9231 20.7383H110.144C114.142 20.7383 117.384 23.9795 117.384 27.9778V49.6962C117.384 53.6944 114.142 56.9357 110.144 56.9357H32.9231C28.9248 56.9357 25.6836 53.6944 25.6836 49.6962V27.9778Z"
          fill="white"
        />
        <path
          d="M32.9229 21.1006H110.145C113.943 21.1008 117.021 24.1794 117.021 27.9775V49.6963C117.021 53.4945 113.943 56.573 110.145 56.5732H32.9229C29.1247 56.5731 26.046 53.4945 26.0459 49.6963V27.9775C26.046 24.1794 29.1247 21.1007 32.9229 21.1006Z"
          stroke="#AFB3BF"
          strokeWidth="0.723948"
        />
      </g>
      <rect x="32.7148" y="30.1641" width="56.9738" height="1.8498" rx="0.924899" fill="#DEE1EB" />
      <rect x="32.7148" y="36.4531" width="73.252" height="1.8498" rx="0.924899" fill="#DEE1EB" />
      <path
        d="M132.928 52.5L41.2277 52.5L41.2277 50.0868C41.2277 46.0886 44.4689 42.8474 48.4672 42.8474L125.688 42.8474C129.687 42.8474 132.928 46.0886 132.928 50.0868L132.928 52.5Z"
        fill="#93C5FF"
      />
      <g filter="url(#filter2_d_46_51003)">
        <path
          d="M41.2285 52.4992C41.2285 48.501 44.4697 45.2598 48.468 45.2598H125.689C129.687 45.2598 132.929 48.501 132.929 52.4992V74.2177C132.929 78.2159 129.687 81.4571 125.689 81.4571H48.468C44.4698 81.4571 41.2285 78.2159 41.2285 74.2177V52.4992Z"
          fill="white"
        />
        <path
          d="M48.4678 45.6221H125.689C129.488 45.6223 132.566 48.7009 132.566 52.499V74.2178C132.566 78.0159 129.488 81.0945 125.689 81.0947H48.4678C44.6696 81.0946 41.5909 78.016 41.5908 74.2178V52.499C41.5909 48.7009 44.6696 45.6222 48.4678 45.6221Z"
          stroke="#AFB3BF"
          strokeWidth="0.723948"
        />
      </g>
      <rect x="48.2578" y="54.6855" width="56.9738" height="1.8498" rx="0.924899" fill="#DEE1EB" />
      <rect x="48.2578" y="60.9746" width="73.252" height="1.8498" rx="0.924899" fill="#DEE1EB" />
    </g>
    <defs>
      <filter
        id="filter0_d_46_51003"
        x="14.7786"
        y="7.42803"
        width="129.048"
        height="84.9271"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5.44907" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51003" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51003" result="shape" />
      </filter>
      <filter
        id="filter1_d_46_51003"
        x="20.6054"
        y="15.6601"
        width="101.857"
        height="46.3536"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.53909" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51003" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51003" result="shape" />
      </filter>
      <filter
        id="filter2_d_46_51003"
        x="36.1503"
        y="40.1816"
        width="101.857"
        height="46.3536"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.53909" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51003" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51003" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const widgets_taskIcon = (
  <svg width="160" height="100" viewBox="0 0 159 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M130.933 33.2305L30.4831 33.2305L30.4831 30.5871C30.4831 26.2073 34.0335 22.6568 38.4133 22.6568L123.002 22.6568C127.382 22.6568 130.933 26.2073 130.933 30.5871L130.933 33.2305Z"
      fill="#F6A09E"
    />
    <g filter="url(#filter0_d_46_51174)">
      <path
        d="M30.4775 33.231C30.4775 28.8513 34.028 25.3008 38.4078 25.3008H122.997C127.377 25.3008 130.927 28.8513 130.927 33.231V67.5953C130.927 71.9751 127.377 75.5256 122.997 75.5256H38.4078C34.028 75.5256 30.4775 71.9751 30.4775 67.5953V33.231Z"
        fill="white"
      />
      <path
        d="M38.4082 25.6973H122.997C127.158 25.6974 130.53 29.0708 130.53 33.2314V67.5957C130.53 71.7562 127.158 75.1288 122.997 75.1289H38.4082C34.2476 75.1289 30.8742 71.7563 30.874 67.5957V33.2314C30.874 29.0707 34.2474 25.6973 38.4082 25.6973Z"
        stroke="#AFB3BF"
        strokeWidth="0.793023"
      />
    </g>
    <circle cx="119.038" cy="63.6286" r="5.28682" fill="#DEE1EB" />
    <rect x="38.1797" y="34.5527" width="62.4099" height="2.02629" rx="1.01315" fill="#DEE1EB" />
    <rect x="38.1797" y="42.5156" width="80.2413" height="2.02629" rx="1.01315" fill="#DEE1EB" />
    <rect x="38.1797" y="50.4141" width="80.2413" height="2.02629" rx="1.01315" fill="#DEE1EB" />
    <rect x="38.4111" y="59.666" width="23.7907" height="7.93023" rx="1.3217" fill="#F5B53D" fillOpacity="0.5" />
    <defs>
      <filter
        id="filter0_d_46_51174"
        x="24.9148"
        y="19.7381"
        width="111.575"
        height="61.35"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.78135" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51174" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51174" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const widgets_mindMapIcon = (
  <svg width="160" height="100" viewBox="0 0 159 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_46_51218)">
      <line
        x1="71.5211"
        y1="49.2299"
        x2="102.443"
        y2="49.2299"
        stroke="#AFB3BF"
        strokeWidth="1.31758"
        strokeLinecap="round"
      />
      <path
        d="M60.4121 49.0866H66.4411C68.4631 49.0868 70.4553 49.5595 72.2487 50.4647C74.0422 51.3699 75.5839 52.6809 76.7434 54.2865L86.8394 68.265C87.9989 69.8706 89.5407 71.1816 91.3341 72.0868C93.1275 72.992 95.1197 73.4647 97.1418 73.4648H105.686"
        stroke="#AFB3BF"
        strokeWidth="1.31758"
        strokeLinecap="round"
      />
      <path
        d="M61.6338 49.0858H67.3354C69.2476 49.0856 71.1316 48.6386 72.8277 47.7825C74.5238 46.9265 75.9818 45.6867 77.0783 44.1682L86.6262 30.9488C87.7227 29.4303 89.1807 28.1905 90.8768 27.3345C92.5728 26.4784 94.4569 26.0314 96.3691 26.0312H104.449"
        stroke="#AFB3BF"
        strokeWidth="1.31758"
        strokeLinecap="round"
      />
      <rect
        x="30.818"
        y="38.3161"
        width="32.1265"
        height="23.0634"
        rx="9.36729"
        fill="#DEEBFF"
        stroke="#7EB0FF"
        strokeWidth="1.10484"
      />
      <rect x="39.0518" y="48.6953" width="16.3776" height="2.20968" rx="1.10484" fill="#7EB0FF" />
      <rect
        x="102.345"
        y="18.6794"
        width="24.574"
        height="14.0003"
        rx="4.52984"
        fill="#B9E9D8"
        stroke="#29CB90"
        strokeWidth="1.10484"
      />
      <rect x="109.446" y="25.166" width="10.4333" height="1.40767" rx="0.703833" fill="#29CB90" />
      <rect
        x="102.345"
        y="42.8473"
        width="24.574"
        height="14.0003"
        rx="4.52984"
        fill="#FFECC9"
        stroke="#F5B53D"
        strokeWidth="1.10484"
      />
      <rect x="109.446" y="48.6641" width="10.4333" height="1.40767" rx="0.703833" fill="#F5B53D" />
      <rect
        x="102.345"
        y="65.5055"
        width="24.574"
        height="14.0003"
        rx="4.52984"
        fill="#F9F5FF"
        stroke="#BB96FF"
        strokeWidth="1.10484"
      />
      <rect x="109.446" y="71.6133" width="10.4333" height="1.40767" rx="0.703833" fill="#BB96FF" />
    </g>
    <defs>
      <filter
        id="filter0_d_46_51218"
        x="24.2236"
        y="12.0849"
        width="109.29"
        height="74.0158"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.02103" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51218" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51218" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const widgets_tableIcon = (
  <svg width="160" height="100" viewBox="0 0 159 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.2119 29.5987C33.2119 28.9941 33.7021 28.5039 34.3067 28.5039H47.4439C48.0485 28.5039 48.5387 28.9941 48.5387 29.5987V33.4304C48.5387 34.035 48.0485 34.5251 47.4439 34.5251H34.3067C33.7021 34.5251 33.2119 34.035 33.2119 33.4304V29.5987Z"
      fill="#EBDEFF"
    />
    <path
      d="M34.3066 28.7695H47.4443C47.9019 28.7698 48.2724 29.141 48.2725 29.5986V33.4307C48.2723 33.8882 47.9019 34.2595 47.4443 34.2598H34.3066C33.8489 34.2597 33.4777 33.8883 33.4775 33.4307V29.5986C33.4776 29.1408 33.8489 28.7696 34.3066 28.7695Z"
      stroke="#AB87E2"
      strokeOpacity="0.9"
      strokeWidth="0.531621"
    />
    <rect
      x="27.4611"
      y="25.424"
      width="14.7951"
      height="10.8418"
      fill="#EBEDF3"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <path
      d="M33.2119 23.0674C33.2119 22.4628 33.7021 21.9727 34.3067 21.9727H47.4439C48.0485 21.9727 48.5387 22.4628 48.5387 23.0674V23.9762C48.5387 24.5808 48.0485 25.071 47.4439 25.071H34.3067C33.7021 25.071 33.2119 24.5808 33.2119 23.9762V23.0674Z"
      fill="#93C5FF"
    />
    <path
      d="M34.3066 22.2383H47.4443C47.9019 22.2385 48.2724 22.6097 48.2725 23.0674V23.9766C48.2723 24.4341 47.9018 24.8044 47.4443 24.8047H34.3066C33.849 24.8047 33.4777 24.4342 33.4775 23.9766V23.0674C33.4776 22.6096 33.8489 22.2383 34.3066 22.2383Z"
      stroke="#AB87E2"
      strokeOpacity="0.9"
      strokeWidth="0.531621"
    />
    <path
      d="M31.7266 19.9023H42.2559V25.8369H27.4609V24.168C27.4611 21.8123 29.3709 19.9025 31.7266 19.9023Z"
      fill="#93C5FF"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="27.4611"
      y="36.1291"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="57.0109"
      y="25.424"
      width="14.7951"
      height="10.8418"
      fill="#EBEDF3"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="57.0109"
      y="19.9025"
      width="14.7951"
      height="5.93422"
      fill="#93C5FF"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="57.0109"
      y="36.1291"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="57.0109"
      y="46.8322"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="57.0109"
      y="57.5373"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="57.0109"
      y="68.0353"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="42.2394"
      y="25.424"
      width="14.7951"
      height="10.8418"
      fill="#EBEDF3"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="42.2394"
      y="19.9025"
      width="14.7951"
      height="5.93422"
      fill="#93C5FF"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="42.2394"
      y="36.1291"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="42.2394"
      y="46.8322"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="42.2394"
      y="57.5373"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="42.2394"
      y="68.0353"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="71.7971"
      y="25.424"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="71.7971"
      y="19.9025"
      width="14.7951"
      height="5.93422"
      fill="#93C5FF"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="101.246"
      y="25.424"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="101.246"
      y="19.9025"
      width="14.7951"
      height="5.93422"
      fill="#93C5FF"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect x="86.676" y="25.424" width="14.7951" height="10.8418" fill="white" stroke="#AFB3BF" strokeWidth="0.531621" />
    <rect
      x="86.676"
      y="19.9025"
      width="14.7951"
      height="5.93422"
      fill="#93C5FF"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="116.123"
      y="25.424"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <path
      d="M126.652 19.9023C129.008 19.9023 130.918 21.8122 130.918 24.168V25.8369H116.123V19.9023H126.652Z"
      fill="#93C5FF"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="71.7971"
      y="36.1291"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="101.246"
      y="36.1291"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="86.676"
      y="36.1271"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="116.123"
      y="36.1271"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="71.7971"
      y="46.8322"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="101.246"
      y="46.8322"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="86.676"
      y="46.8322"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="116.123"
      y="46.8322"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="71.7971"
      y="57.5373"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="71.7971"
      y="68.0353"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="101.246"
      y="57.5373"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="101.246"
      y="68.0353"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="86.676"
      y="57.5373"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="86.676"
      y="68.0353"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="116.123"
      y="57.5373"
      width="14.7951"
      height="10.8418"
      fill="#FEFEFE"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <path
      d="M130.918 68.0352V74.6113C130.918 76.9672 129.008 78.877 126.652 78.877H116.123V68.0352H130.918Z"
      fill="#EBEDF3"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="27.4611"
      y="46.8322"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <rect
      x="27.4611"
      y="57.5373"
      width="14.7951"
      height="10.8418"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <path
      d="M42.2559 68.0352V78.877H31.7266C29.3708 78.8768 27.4609 76.9671 27.4609 74.6113V68.0352H42.2559Z"
      fill="white"
      stroke="#AFB3BF"
      strokeWidth="0.531621"
    />
    <g filter="url(#filter0_d_46_51024)">
      <rect x="80.5605" y="30.0664" width="14.1093" height="14.1093" rx="1.22689" fill="#9EDEC8" />
      <rect x="82.4082" y="33.1348" width="6.13448" height="0.613448" rx="0.306724" fill="#00B875" />
    </g>
    <g filter="url(#filter1_d_46_51024)">
      <rect x="62.7686" y="60.7383" width="14.1093" height="14.1093" rx="1.22689" fill="#D5B8FF" />
      <rect x="64.873" y="63.8047" width="7.01083" height="0.613448" rx="0.306724" fill="#A47BDF" />
    </g>
    <g filter="url(#filter2_d_46_51024)">
      <rect x="111.229" y="49.082" width="14.1093" height="14.1093" rx="1.22689" fill="#FDD48B" />
      <rect x="113.331" y="52.1504" width="7.01083" height="0.613448" rx="0.306724" fill="#EE9F0E" />
    </g>
    <g filter="url(#filter3_d_46_51024)">
      <rect x="36.3936" y="40.4941" width="14.1093" height="14.1093" rx="1.22689" fill="#FFCEE3" />
      <rect x="38.4951" y="43.5605" width="7.01083" height="0.613448" rx="0.306724" fill="#FF8894" />
    </g>
    <defs>
      <filter
        id="filter0_d_46_51024"
        x="79.3337"
        y="29.453"
        width="16.5632"
        height="16.5632"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.613447" />
        <feGaussianBlur stdDeviation="0.613447" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51024" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51024" result="shape" />
      </filter>
      <filter
        id="filter1_d_46_51024"
        x="61.5417"
        y="60.1248"
        width="16.5632"
        height="16.5632"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.613447" />
        <feGaussianBlur stdDeviation="0.613447" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51024" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51024" result="shape" />
      </filter>
      <filter
        id="filter2_d_46_51024"
        x="110.003"
        y="48.4686"
        width="16.5632"
        height="16.5632"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.613447" />
        <feGaussianBlur stdDeviation="0.613447" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51024" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51024" result="shape" />
      </filter>
      <filter
        id="filter3_d_46_51024"
        x="35.1667"
        y="39.8807"
        width="16.5632"
        height="16.5632"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.613447" />
        <feGaussianBlur stdDeviation="0.613447" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46_51024" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46_51024" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const widgets_dependencyMappingIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="159" height="99" viewBox="0 0 159 99" fill="none">
    <rect
      x="0.574254"
      y="0.574254"
      width="157.424"
      height="97.6231"
      rx="6.31679"
      fill="#F8F9FC"
      stroke="#EBEDF3"
      strokeWidth="1.14851"
    />
    <g filter="url(#filter0_d_374_2195)">
      <path d="M78.3684 72.3683L78.3684 81.7235" stroke="#848199" strokeWidth="0.691019" strokeDasharray="0.72 1.44" />
      <path d="M96.0466 50.4017V30.7891" stroke="#848199" strokeWidth="0.691019" strokeDasharray="0.72 1.44" />
      <path
        d="M47.6176 43.6022C47.7525 43.4673 47.7525 43.2485 47.6176 43.1136L45.4188 40.9148C45.2838 40.7799 45.0651 40.7799 44.9302 40.9148C44.7952 41.0497 44.7952 41.2685 44.9302 41.4034L46.8847 43.3579L44.9302 45.3124C44.7952 45.4473 44.7952 45.6661 44.9302 45.801C45.0651 45.936 45.2838 45.936 45.4188 45.801L47.6176 43.6022ZM32.0012 43.3579V43.7034H47.3733V43.3579V43.0124H32.0012V43.3579Z"
        fill="#848199"
      />
      <rect x="16" y="35.9867" width="20.9685" height="14.8853" rx="3.11842" fill="#E9DAFE" />
      <rect x="16.5" y="36.4867" width="19.9685" height="13.8853" rx="2.61842" stroke="#AB87E2" strokeOpacity="0.9" />
      <rect x="21" y="42.9999" width="11" height="1" rx="0.5" fill="#B18FE5" />
      <rect x="48.7236" y="38.5657" width="20.8289" height="8.35526" rx="2.61842" fill="#9CDBC5" stroke="#00B875" />
      <rect x="54" y="42.0001" width="10" height="1" rx="0.5" fill="#00B875" />
      <rect x="68.4736" y="80.1453" width="20.8289" height="8.35526" rx="2.61842" fill="#CBE2F7" stroke="#2198FF" />
      <rect x="73.5" y="84" width="11" height="1" rx="0.5" fill="#2198FF" />
      <rect x="85.6453" y="45.012" width="20.9685" height="14.8825" rx="3.11842" fill="#E9DAFE" />
      <rect x="86.1453" y="45.512" width="19.9685" height="13.8825" rx="2.61842" stroke="#AB87E2" strokeOpacity="0.9" />
      <rect x="91.0002" y="51.9998" width="10" height="1" rx="0.5" fill="#B18FE5" />
    </g>
    <rect
      x="86.3533"
      y="20.5059"
      width="13.8574"
      height="13.8574"
      rx="1.16952"
      transform="rotate(-45 86.3533 20.5059)"
      fill="#FFE7BE"
      stroke="#F5B53D"
    />
    <rect x="92.0002" y="20" width="8" height="1" rx="0.5" fill="#F5B53D" />
    <circle cx="133.98" cy="40.6643" r="9.375" fill="#F1A0C3" stroke="#E9478B" />
    <rect x="129" y="39.9999" width="10" height="1" rx="0.5" fill="#E9478B" />
    <path
      d="M86.407 20.6373C86.541 20.5034 86.541 20.2862 86.407 20.1522L84.224 17.9692C84.09 17.8353 83.8729 17.8353 83.7389 17.9692C83.6049 18.1032 83.6049 18.3204 83.7389 18.4543L85.6793 20.3948L83.7389 22.3352C83.6049 22.4692 83.6049 22.6864 83.7389 22.8203C83.8729 22.9543 84.09 22.9543 84.224 22.8203L86.407 20.6373ZM70.0526 42.7435V43.0865H73.171V42.7435V42.4004H70.0526V42.7435ZM76.2895 39.625H76.6325V23.5132H76.2895H75.9464V39.625H76.2895ZM79.4079 20.3948V20.7378H86.1645V20.3948V20.0517H79.4079V20.3948ZM76.2895 23.5132H76.6325C76.6325 21.9804 77.8751 20.7378 79.4079 20.7378V20.3948V20.0517C77.4962 20.0517 75.9464 21.6015 75.9464 23.5132H76.2895ZM73.171 42.7435V43.0865C75.0827 43.0865 76.6325 41.5367 76.6325 39.625H76.2895H75.9464C75.9464 41.1578 74.7038 42.4004 73.171 42.4004V42.7435Z"
      fill="#848199"
    />
    <path
      d="M123.308 41.4268C123.442 41.2928 123.442 41.0756 123.308 40.9416L121.125 38.7586C120.991 38.6247 120.774 38.6247 120.64 38.7586C120.506 38.8926 120.506 39.1098 120.64 39.2438L122.581 41.1842L120.64 43.1247C120.506 43.2586 120.506 43.4758 120.64 43.6098C120.774 43.7437 120.991 43.7437 121.125 43.6098L123.308 41.4268ZM106.434 52.6184V52.9614H109.754V52.6184V52.2754H106.434V52.6184ZM112.872 49.5H113.215V44.3026H112.872H112.529V49.5H112.872ZM115.991 41.1842V41.5272H123.066V41.1842V40.8412H115.991V41.1842ZM112.872 44.3026H113.215C113.215 42.7698 114.458 41.5272 115.991 41.5272V41.1842V40.8412C114.079 40.8412 112.529 42.3909 112.529 44.3026H112.872ZM109.754 52.6184V52.9614C111.666 52.9614 113.215 51.4117 113.215 49.5H112.872H112.529C112.529 51.0328 111.287 52.2754 109.754 52.2754V52.6184Z"
      fill="#848199"
    />
    <path
      d="M96.282 60.3087C96.148 60.1747 95.9308 60.1747 95.7969 60.3087L93.6139 62.4917C93.4799 62.6256 93.4799 62.8428 93.6139 62.9768C93.7478 63.1107 93.965 63.1107 94.099 62.9768L96.0394 61.0363L97.9799 62.9768C98.1138 63.1107 98.331 63.1107 98.465 62.9768C98.5989 62.8428 98.5989 62.6256 98.465 62.4917L96.282 60.3087ZM59.6578 47.421H59.3148V69.25H59.6578H60.0009V47.421H59.6578ZM62.7763 72.3684V72.7114H92.921V72.3684V72.0254H62.7763V72.3684ZM96.0394 69.25H96.3824V60.5512H96.0394H95.6964V69.25H96.0394ZM92.921 72.3684V72.7114C94.8327 72.7114 96.3824 71.1617 96.3824 69.25H96.0394H95.6964C95.6964 70.7828 94.4538 72.0254 92.921 72.0254V72.3684ZM59.6578 69.25H59.3148C59.3148 71.1617 60.8646 72.7114 62.7763 72.7114V72.3684V72.0254C61.2434 72.0254 60.0009 70.7828 60.0009 69.25H59.6578Z"
      fill="#848199"
    />
    <defs>
      <filter
        id="filter0_d_374_2195"
        x="9.731"
        y="27.6546"
        width="103.152"
        height="70.7494"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.1345" />
        <feGaussianBlur stdDeviation="3.1345" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_374_2195" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_374_2195" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const widgets_timelineIcon = (
  <svg width="160px" height="100px" viewBox="0 0 160 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1091_208)">
      <rect x="84.6467" y="75.6272" width="28.8629px" height="6.24064px" rx="0.78008" fill="#FFE7BC" />
    </g>
    <g filter="url(#filter1_d_1091_208)">
      <rect x="19.1201" y="75.6272" width="39.004px" height="6.24064px" rx="0.78008" fill="#E7D6FF" />
    </g>
    <g filter="url(#filter2_d_1091_208)">
      <rect x="58.1245" y="75.6272" width="26.5227px" height="6.24064px" rx="0.78008" fill="#BEDCFF" />
    </g>
    <g filter="url(#filter3_d_1091_208)">
      <rect x="113.51" y="75.6273" width="25.7426px" height="6.24064px" rx="0.78008" fill="#BBE7D8" />
    </g>
    <g filter="url(#filter4_d_1091_208)">
      <path d="M30.9996 23L30.9996 79" stroke="#A377E8" strokeWidth="0.749453px" />
    </g>
    <circle cx="31.02" cy="78.7473" r="2.91564" fill="#A377E8" stroke="#A377E8" strokeWidth="0.409359px" />
    <circle cx="30.9996" cy="22" r="1.86464" fill="#A377E8" stroke="#A377E8" strokeWidth="0.270729px" />
    <circle cx="58.1239" cy="78.7467" r="2.91564" fill="#0091E5" stroke="#0091E5" strokeWidth="0.409359px" />
    <circle cx="57.9998" cy="32.9991" r="1.86464" fill="#0091E5" stroke="#0091E5" strokeWidth="0.270729px" />
    <g filter="url(#filter5_d_1091_208)">
      <path d="M57.9998 32.9991L57.9998 78.9991" stroke="#0091E5" strokeWidth="0.749453px" strokeLinecap="round" />
    </g>
    <g filter="url(#filter6_d_1091_208)">
      <path d="M113.51 52.615V78.7477" stroke="#00B875" strokeWidth="0.749453px" />
    </g>
    <circle cx="113.511" cy="78.7479" r="2.91564" fill="#00B875" stroke="#00B875" strokeWidth="0.409359px" />
    <circle cx="139.253" cy="78.7479" r="2.91564" fill="#113357" stroke="#113357" strokeWidth="0.409359px" />
    <circle cx="19.1208" cy="78.7479" r="2.91564" fill="#113357" stroke="#113357" strokeWidth="0.409359px" />
    <circle cx="113.5" cy="50.9995" r="1.86464" fill="#00B875" stroke="#00B875" strokeWidth="0.270729px" />
    <g filter="url(#filter7_d_1091_208)">
      <path d="M85.6478 41.3036V78.7474" stroke="#FDBF4D" strokeWidth="0.749453px" />
    </g>
    <circle cx="85.647" cy="78.7462" r="2.91564" fill="#FDBF4D" stroke="#FDBF4D" strokeWidth="0.409359px" />
    <circle cx="85.5999" cy="40.0009" r="1.86464" fill="#FDBF4D" stroke="#FDBF4D" strokeWidth="0.270729px" />
    <g filter="url(#filter8_d_1091_208)">
      <path
        d="M86.0003 42.9998H97.8686C98.4936 42.9998 99.0003 43.5064 99.0003 44.1314V54.8681C99.0003 55.4931 98.4936 55.9998 97.8686 55.9998H86.0003V42.9998Z"
        fill="#FDD48B"
      />
    </g>
    <g filter="url(#filter9_d_1091_208)">
      <path
        d="M58.3993 36H70.2676C70.8926 36 71.3993 36.5067 71.3993 37.1317V47.8683C71.3993 48.4933 70.8926 49 70.2676 49H58.3993V36Z"
        fill="#95C6FF"
      />
    </g>
    <g filter="url(#filter10_d_1091_208)">
      <path
        d="M31.3797 24.9996H43.248C43.873 24.9996 44.3797 25.5063 44.3797 26.1313V36.8679C44.3797 37.493 43.873 37.9996 43.248 37.9996H31.3797V24.9996Z"
        fill="#D8BCFF"
      />
    </g>
    <g filter="url(#filter11_d_1091_208)">
      <path
        d="M113.9 53.9996H125.769C126.394 53.9996 126.9 54.5063 126.9 55.1313V65.8679C126.9 66.493 126.394 66.9996 125.769 66.9996H113.9V53.9996Z"
        fill="#8DD0B9"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1091_208"
        x="77.8476"
        y="72.2276"
        width="42.4612px"
        height="19.8388px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter1_d_1091_208"
        x="12.321"
        y="72.2276"
        width="52.6022px"
        height="19.8388px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter2_d_1091_208"
        x="51.3254"
        y="72.2276"
        width="40.1209px"
        height="19.8388px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter3_d_1091_208"
        x="106.71"
        y="72.2278"
        width="39.3409px"
        height="19.8388px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter4_d_1091_208"
        x="23.8258"
        y="19.6004"
        width="14.3477px"
        height="69.5982px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter5_d_1091_208"
        x="50.8259"
        y="29.2248"
        width="14.3477px"
        height="60.3477px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter6_d_1091_208"
        x="106.336"
        y="49.2154"
        width="14.3477px"
        height="39.7309px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter7_d_1091_208"
        x="78.4739"
        y="37.904"
        width="14.3477px"
        height="51.0421px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.39956" />
        <feGaussianBlur stdDeviation="3.39956" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter8_d_1091_208"
        x="81.7509"
        y="40.875"
        width="21.4989px"
        height="21.4989px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.12472" />
        <feGaussianBlur stdDeviation="2.12472" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter9_d_1091_208"
        x="54.1498"
        y="33.8753"
        width="21.4989px"
        height="21.4989px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.12472" />
        <feGaussianBlur stdDeviation="2.12472" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter10_d_1091_208"
        x="27.1303"
        y="22.8749"
        width="21.4989px"
        height="21.4989px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.12472" />
        <feGaussianBlur stdDeviation="2.12472" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
      <filter
        id="filter11_d_1091_208"
        x="109.651"
        y="51.8749"
        width="21.4989px"
        height="21.4989px"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.12472" />
        <feGaussianBlur stdDeviation="2.12472" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1091_208" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1091_208" result="shape" />
      </filter>
    </defs>
  </svg>
);
